
import { ChannelkartNetworkGet } from "./networkService";



export async function fetchHistoricalSummary(env : string, lob : string ){
 try{
  const response = await ChannelkartNetworkGet(`https://analytics.sellina.io/historicalDataCleanup?env=${env}&lob=${lob}`);
  // const response = await ChannelkartNetworkGet(`http://localhost:3001/historicalDataCleanup?env=local&lob=kbpldemo&source=portal`);
  
   if(response.data){
    return groupByGroupId(response.data.data);
    }
   return [];
  }catch(err){
    return [];
  }
}

export const downloadS3File = async (s3Path: string) => {
  const authContext = JSON.parse(localStorage.authContext);
  try { 
    const response = await ChannelkartNetworkGet(`https://analytics.sellina.io/downloadS3File?env=${authContext.env}&lob=${authContext.user.lob}&path=${encodeURIComponent(s3Path)}`);
   // const response = await ChannelkartNetworkGet(`http://localhost:3001/downloadS3File?env=${authContext.env}&lob=${authContext.user.lob}&path=${encodeURIComponent(s3Path)}`);
    
    if (response.status!=200) throw new Error("Failed to get download URL");

    const { presignedUrl } = response.data;

    const link = document.createElement("a");
    link.href = presignedUrl;
    link.download = ""; // Let browser decide filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
    alert("Failed to download the file.");
  }
};

const groupByGroupId = (data: any[]) => {
    const grouped: Record<
      string,
      { group_Id: string; taskDate: string; groupItems: any[];status:string }
    > = {};
  
    data.forEach((record) => {
      const key = `${record.group_id}`;
  
      if (!grouped[key]) {
        grouped[key] = {
          group_Id: record.group_id,
          taskDate: new Date(record.taskdate).toISOString().split('T')[0],
          groupItems: [],
          status:''
        };
      }
  
      grouped[key].groupItems.push(record);
    });
  
    return Object.values(grouped).map((group) => {
      const allCompleted = group.groupItems.every((item) => item.status === "completed");
    
      return {
        group_Id: group.group_Id,
        taskDate: group.taskDate,
        groupItems: JSON.stringify(group.groupItems),
        status: allCompleted ? "Success" : "Partial"
      };
    }).sort((a, b) => new Date(b.taskDate).getTime() - new Date(a.taskDate).getTime());;
  
  };